module.exports = __webpack_public_path__ + "static/img/lb_img_5.24a7ec91.png";